export default function getCompleteApiUrl(config: any, route: string) {
    if (config.isStandalone) {
        return "//" + config.apiAddr + config.apiRoute + route
    } else {
        return config.apiRoute + route
    }
}